import { IAuthServiceMock } from "@/services";

export const mockAuthService = (): IAuthServiceMock => ({
  getUser: jest.fn(),
  getSignedIn: jest.fn(),
  signIn: jest.fn(),
  logout: jest.fn(),
});
